import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import HkClassics from "@/pages/home/components/HkClassics";
import ActionZone from "@/pages/home/components/ActionZone";
import WuxiaZone from "@/pages/home/components/WuxiaZone";
import NostalgiaTimeline from "@/pages/home/components/NostalgiaTimeline";
import KeywordSection from "@/pages/home/components/KeywordSection";
import BrowseFilter from "@/pages/home/components/BrowseFilter";
import WatchGuide from "@/pages/home/components/WatchGuide";
import FaqSection from "@/pages/home/components/FaqSection";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="w-full min-h-screen bg-background-50">
      <Navbar />
      <main className="w-full">
        <Hero />
        <HkClassics />
        <ActionZone />
        <WuxiaZone />
        <NostalgiaTimeline />
        <KeywordSection />
        <BrowseFilter />
        <WatchGuide />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}